"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadModal = void 0;
const button_1 = require("client/components/material/button");
const ui_1 = require("client/components/ui");
const Backup_1 = require("material-ui-icons/Backup");
const react_1 = require("react");
const React = require("react");
require("./upload-modal.less");
class UploadModal extends react_1.Component {
    constructor() {
        super(...arguments);
        this.handleCancelClick = () => {
            this.props.onCancel();
        };
        this.handleDrop = async (accepted) => {
            console.log("this.props ----", this.props);
            if (accepted.length) {
                console.log("this.props.onDrop", this.props.onDrop);
                this.props.onDrop(accepted);
                if (this.props.inPharmacy) {
                    this.props.callback();
                }
                this.props.onCancel();
            }
        };
    }
    renderMessage(content) {
        return React.createElement("span", { dangerouslySetInnerHTML: { __html: content } });
    }
    render() {
        const { title, message, isCancelPrimary = true } = this.props;
        return (React.createElement("div", { className: "upload-modal" },
            React.createElement("div", { className: "modal-background", onClick: this.handleCancelClick }),
            React.createElement("div", { className: "modal-body" },
                React.createElement("div", { className: "modal-title" }, title),
                React.createElement("div", { className: "modal-message" }, this.renderMessage(message)),
                React.createElement(ui_1.UiDropzone, { className: "upload-modal__dropzone", onDrop: this.handleDrop, loading: false },
                    React.createElement(Backup_1.default, { className: "upload-modal__download-icon" }),
                    React.createElement("p", null,
                        React.createElement("strong", null, "Drag & Drop Documents")),
                    React.createElement("div", { className: "upload-modal__dropzone-button" },
                        React.createElement(button_1.MaterialButton, { flat: true, className: "browse-button" }, "Browse to Upload"))),
                React.createElement("div", { className: "modal-button-group" },
                    isCancelPrimary !== true && (React.createElement(button_1.MaterialButton, { className: "modal-button button-non-primary", onClick: this.handleCancelClick }, "Cancel")),
                    isCancelPrimary === true && (React.createElement(button_1.MaterialButton, { primary: true, className: "modal-button modal-button--cancel", onClick: this.handleCancelClick }, "Cancel"))))));
    }
}
exports.UploadModal = UploadModal;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/upload-modal/upload-modal.tsx
// module id = 3180
// module chunks = 0